import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref, ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ExpectedDateModal } from './components/ExpectedDateModal';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const fetchInvestment = inject('fetchInvestment', () => ({}));

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const isFetchingInvestment = inject('isFetchingInvestment') as Ref<boolean>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const isExpectedDateModalOpen = ref(false);

const title = computed(() => {
  return `R$ ${amountFormatted.value}`;
});

function handleInvestment() {
  fetchInvestment();
}

function handleExpectedDateModal() {
  isExpectedDateModalOpen.value = !isExpectedDateModalOpen.value;
}

return { __sfc: true,fetchInvestment, investmentDetails, isFetchingInvestment, amountFormatted, isExpectedDateModalOpen, title, handleInvestment, handleExpectedDateModal, HeadingDisplay, ContentDisplay, Heading, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, ExpectedDateModal }
}

})